var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWgtAllow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 1.063,
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 29.896,
    height: 29.896
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DEF",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M16,30.959c0,0,7.845-2.028,9.535-4.016 c3.61-4.249,5.446-21.794,5.446-21.794S25.815,2.353,16,1.063C6.183,2.353,1.019,5.149,1.019,5.149s1.834,17.545,5.445,21.794 C8.154,28.931,16,30.959,16,30.959z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#7F7F7F",
    strokeMiterlimit: 10,
    d: "M16.479,28.828c0,0,6.253-2.008,7.666-3.67 c3.021-3.556,4.557-18.235,4.557-18.235S24.69,4.894,16.479,3.814V28.828z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "MDEF",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M16,30.959c0,0,7.845-2.028,9.535-4.016 c3.61-4.249,5.446-21.794,5.446-21.794S25.815,2.353,16,1.063C6.183,2.353,1.019,5.149,1.019,5.149s1.834,17.545,5.445,21.794 C8.154,28.931,16,30.959,16,30.959z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#7F7F7F",
    strokeMiterlimit: 10,
    d: "M16.479,28.828c0,0,6.253-2.008,7.666-3.67 c3.021-3.556,4.557-18.235,4.557-18.235S24.69,4.894,16.479,3.814V28.828z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "DB",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.949,30.956c0,0,7.815-2.024,9.498-4.001c3.596-4.233,5.422-21.708,5.422-21.708 s-5.143-2.785-14.919-4.07C6.171,2.462,1.028,5.247,1.028,5.247s1.828,17.475,5.424,21.708 C8.134,28.932,15.949,30.956,15.949,30.956z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M30.365,9.214 c0.335-2.359,0.503-3.967,0.503-3.967s-1.252-0.678-3.693-1.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "8.3817,2.0954",
    d: " M25.18,3.092c-2.365-0.697-5.452-1.418-9.231-1.915c-4.335,0.57-7.76,1.435-10.229,2.221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M4.722,3.729 C2.279,4.569,1.028,5.247,1.028,5.247s0.168,1.608,0.503,3.967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "7.4684,1.8671",
    d: " M1.805,11.061c0.854,5.488,2.407,13.259,4.646,15.895c1.683,1.977,9.497,4.001,9.497,4.001s7.815-2.024,9.498-4.001 c2.368-2.788,3.968-11.317,4.785-16.817"
  }))), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M15.655,23.996c0,0,4.16-1.077,5.057-2.13 C22.627,19.61,23.6,10.305,23.6,10.305s-2.739-1.483-7.944-2.167c-5.208,0.685-7.947,2.167-7.947,2.167s0.973,9.305,2.888,11.561 C11.493,22.919,15.655,23.996,15.655,23.996z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#7F7F7F",
    strokeMiterlimit: 10,
    d: "M15.908,22.625c0,0,3.316-0.825,4.066-1.705 c1.604-1.888,2.416-9.674,2.416-9.674s-2.126-1.076-6.482-1.649V22.625z"
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M26.12,12.155 c0.349-2.286,0.524-3.965,0.524-3.965s-1.266-0.685-3.725-1.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "9.7348,2.4337",
    d: " M20.573,6.106c-1.372-0.33-2.972-0.64-4.791-0.879c-2.367,0.311-4.36,0.743-5.967,1.181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M8.644,6.747 C6.185,7.504,4.919,8.189,4.919,8.189s0.176,1.679,0.525,3.965"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "7.6124,1.9031",
    d: "M5.75,14.03 c0.655,3.777,1.697,8.292,3.118,9.965c1.226,1.438,6.915,2.912,6.915,2.912s5.689-1.474,6.914-2.912 c1.54-1.814,2.635-6.965,3.274-10.897"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M28.137,10.702 c0.341-2.327,0.512-3.964,0.512-3.964s-1.259-0.681-3.709-1.486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "6.8273,1.7068",
    d: " M23.31,4.754c-1.979-0.561-4.494-1.127-7.527-1.526c-3.466,0.456-6.256,1.129-8.341,1.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M6.625,5.251 C4.174,6.056,2.916,6.737,2.916,6.737s0.171,1.638,0.512,3.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "7.509,1.8773",
    d: " M3.715,12.558c0.758,4.657,2.054,10.752,3.878,12.898c1.451,1.705,8.189,3.45,8.189,3.45s6.738-1.745,8.189-3.45 c1.947-2.292,3.293-9.087,4.025-13.826"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SPD",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M16.146,7.016c0,0,2.505,1.896,3.407,2.369c1.195,0.625,4.974,2.024,4.974,2.024 s-0.553,2.404-1.163,2.886c-0.342,0.271-1.729,0.259-1.729,0.259l-0.698,5.112c0,0,1.784,2.145,3.178,3.504 c0.356,0.348,0.867,0.854,1.198,0.881c1.041,0.09,3.958-0.502,4.57,0.346c0.544,0.75,0.54,1.445,0.551,2.373 c0.003,0.389-0.151,1.395-0.151,1.395s0.672,0.359,0.631,0.754c-0.036,0.359-0.86,1.156-0.86,1.156l-9.525-0.395l-3.445-1.738 l-1.116-1.168l-1.19,0.268c0,0-4.875-1.967-5.892-3.088c-0.197-0.217-0.612-1.002-0.488-1.266 c0.129-0.277,0.624-0.424,0.624-0.424s0.14-0.807,0.117-1.285c-0.035-0.723,0.86-1.906,1.25-2.609 c0.368-0.662,1.486-1.323,2.033-1.729c0.361-0.267,0.769-1.226,0.97-1.628c0.469-0.938,1.277-3.992,1.277-3.992 s-1.331-0.942-1.312-1.426C13.395,8.646,16.146,7.016,16.146,7.016z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M23.492,25.098c0,0,0.287-0.465,0.626-0.854c0.083-0.1,0.146-0.229,0.234-0.307 c0.098-0.063,0.217-0.082,0.332-0.08c0.227,0,0.455,0.113,0.455,0.113l0.057,0.082c0,0,0.022,0.254-0.06,0.465 c-0.04,0.109-0.101,0.213-0.196,0.281c-0.104,0.055-0.247,0.066-0.37,0.107c-0.485,0.174-1.021,0.273-1.021,0.273L23.492,25.098z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M21.45,23.162c0,0,0.578-0.289,1.167-0.488c0.146-0.055,0.29-0.143,0.43-0.174 c0.142-0.014,0.28,0.021,0.401,0.076c0.241,0.1,0.418,0.303,0.418,0.303l0.012,0.1c0,0-0.125,0.238-0.337,0.391 c-0.105,0.082-0.231,0.148-0.372,0.166c-0.144,0.002-0.303-0.049-0.458-0.068c-0.619-0.057-1.249-0.205-1.249-0.205L21.45,23.162 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M18.951,13.383c0,0,0.76,0.078,1.485,0.24c0.184,0.037,0.379,0.042,0.543,0.095 c0.158,0.068,0.286,0.177,0.387,0.292c0.204,0.223,0.288,0.499,0.288,0.499l-0.039,0.093c0,0-0.254,0.135-0.557,0.147 c-0.152,0.01-0.32-0.004-0.479-0.068c-0.152-0.079-0.295-0.214-0.449-0.318c-0.626-0.401-1.218-0.886-1.218-0.885L18.951,13.383z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M11.489,23.389c0,0,0.848,0.381,1.673,0.801c0.209,0.1,0.422,0.193,0.612,0.297 c0.185,0.111,0.34,0.246,0.475,0.357c0.262,0.236,0.405,0.445,0.405,0.445l-0.025,0.043c0,0-0.252-0.027-0.584-0.148 c-0.162-0.066-0.353-0.141-0.539-0.252c-0.181-0.117-0.363-0.262-0.55-0.4c-0.758-0.531-1.492-1.1-1.492-1.1L11.489,23.389z"
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M4.373,24.576 c-0.199-0.254-0.622-1.164-0.5-1.473c0.127-0.32,0.62-0.482,0.62-0.482s0.132-0.93,0.105-1.486 c-0.042-0.836,0.842-2.197,1.226-3.008c0.363-0.766,1.475-1.519,2.018-1.984C8.2,15.837,8.6,14.731,8.796,14.267 c0.46-1.081,1.24-4.609,1.24-4.609S8.696,8.555,8.71,7.995c0.029-1.099,2.766-2.958,2.766-2.958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M1.857,21.467 c-0.198-0.254-0.622-1.164-0.5-1.471c0.127-0.322,0.277-0.648,0.277-0.648s0.474-0.768,0.448-1.322 c-0.042-0.836,0.842-2.198,1.226-3.009c0.363-0.766,1.475-1.519,2.018-1.984c0.358-0.306,0.758-1.412,0.955-1.876 c0.46-1.081,0.308-4.141,0.308-4.141S6.182,5.445,6.195,4.885c0.029-1.099,2.767-2.958,2.767-2.958"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 1.129,
    y1: 9.575,
    x2: 17.734,
    y2: 15.303
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 6.224,
    y1: 15.042,
    x2: 15.911,
    y2: 17.939
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 3.892,
    y1: 18.084,
    x2: 17.734,
    y2: 22.236
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ACC",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M3.412,11.491c0-4.438,3.598-8.036,8.036-8.036v2.824 c-2.879,0-5.212,2.333-5.212,5.212H3.412z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.887,
    y: 1.063,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 2.223,
    height: 5.974
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M20.549,3.455c4.438,0,8.036,3.598,8.036,8.036h-2.823 c0-2.879-2.335-5.212-5.213-5.212V3.455z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.004,
    y: 14.931,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.974,
    height: 2.223
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M28.585,20.592c0,4.438-3.598,8.036-8.036,8.036v-2.824 c2.878,0,5.213-2.333,5.213-5.212H28.585z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.887,
    y: 25.048,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 2.223,
    height: 5.974
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M11.448,28.628c-4.438,0-8.036-3.598-8.036-8.036h2.824 c0,2.879,2.333,5.212,5.212,5.212V28.628z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 14.93,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.974,
    height: 2.223
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M17.442,16.375c0,0.796-0.646,1.442-1.444,1.442 s-1.444-0.646-1.444-1.442c0-0.8,0.646-1.445,1.444-1.445S17.442,15.575,17.442,16.375z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "MACC",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M3.412,11.491c0-4.438,3.598-8.036,8.036-8.036 v2.824c-2.879,0-5.212,2.333-5.212,5.212H3.412z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.887,
    y: 1.063,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 2.223,
    height: 5.974
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M20.549,3.455c4.438,0,8.036,3.598,8.036,8.036 h-2.823c0-2.879-2.335-5.212-5.213-5.212V3.455z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.004,
    y: 14.931,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.974,
    height: 2.223
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M28.585,20.592c0,4.438-3.598,8.036-8.036,8.036 v-2.824c2.878,0,5.213-2.333,5.213-5.212H28.585z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.887,
    y: 25.048,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 2.223,
    height: 5.974
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M11.448,28.628 c-4.438,0-8.036-3.598-8.036-8.036h2.824c0,2.879,2.333,5.212,5.212,5.212V28.628z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 14.93,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.974,
    height: 2.223
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M17.442,16.375c0,0.796-0.646,1.442-1.444,1.442 s-1.444-0.646-1.444-1.442c0-0.8,0.646-1.445,1.444-1.445S17.442,15.575,17.442,16.375z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M3.541,6.747c5.954-0.586,17.948,0.385,17.993,9.267 l-3.404,0.324l5.648,4.183l4.67-5.202l-3.223,0.285C25.165,3.362,10.458,1.939,2.25,2.747L3.541,6.747z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    cx: 23.563,
    cy: 26.417,
    rx: 2.104,
    ry: 0.875
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeDasharray: "2.9039,2.9039",
    d: "M31.037,26.42 c0,1.723-3.365,3.125-7.516,3.125s-7.517-1.402-7.517-3.125c0-1.73,3.367-3.125,7.517-3.125S31.037,24.689,31.037,26.42z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "RNG",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 4.51,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.023,
    height: 19.251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.042,
    y: 4.51,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.024,
    height: 19.251
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "30.822,14.134 20.944,3.335 20.944,4.51 11.066,4.51  11.066,23.761 20.944,23.761 20.944,24.934  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "1.019,28.229 1.019,30.125 10.953,30.125  10.953,28.229  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "10.953,28.229 10.953,30.125  20.887,30.125 20.887,28.229  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "20.887,28.229 20.887,30.125  30.82,30.125 30.82,28.229  "
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "MRNG",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 4.51,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.023,
    height: 19.251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.042,
    y: 4.51,
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 5.024,
    height: 19.251
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "30.822,14.134 20.944,3.335  20.944,4.51 11.066,4.51 11.066,23.761 20.944,23.761 20.944,24.934  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "1.019,28.229 1.019,30.125 10.953,30.125  10.953,28.229  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "10.953,28.229 10.953,30.125  20.887,30.125 20.887,28.229  "
  }), /*#__PURE__*/React.createElement("polyline", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "20.887,28.229 20.887,30.125  30.82,30.125 30.82,28.229  "
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "12.551,9.074 15.248,2.27 17.948,9.074  27.02,3.816 21.763,12.889 28.564,15.586 21.763,18.285 27.021,27.357 17.948,22.1 15.25,28.902 12.551,22.1 3.477,27.355  8.733,18.285 1.931,15.586 8.733,12.889 3.477,3.816  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "POW",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "13.163,9.154 15.993,2.014 18.826,9.154 28.344,3.636  22.829,13.156 29.965,15.986 22.829,18.818 28.347,28.338 18.826,22.821 15.995,29.959 13.163,22.821 3.642,28.336 9.157,18.818  2.019,15.986 9.157,13.156 3.642,3.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "14.64,12.806 15.968,9.456  17.297,12.806 21.762,10.217 19.175,14.683 22.522,16.011 19.175,17.34 21.764,21.806 17.297,19.218 15.969,22.565 14.64,19.218  10.173,21.805 12.761,17.34 9.413,16.011 12.761,14.683 10.173,10.217  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "MPOW",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "13.163,9.154 15.993,2.014  18.826,9.154 28.344,3.636 22.829,13.156 29.965,15.986 22.829,18.818 28.347,28.338 18.826,22.821 15.995,29.959 13.163,22.821  3.642,28.336 9.157,18.818 2.019,15.986 9.157,13.156 3.642,3.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "14.64,12.806 15.968,9.456  17.297,12.806 21.762,10.217 19.175,14.683 22.522,16.011 19.175,17.34 21.764,21.806 17.297,19.218 15.969,22.565 14.64,19.218  10.173,21.805 12.761,17.34 9.413,16.011 12.761,14.683 10.173,10.217  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "DMG",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M12.442,19.522l3.985,3.984c0,0,6.856-7.042,8.925-10.441 c1.379-2.262,4.377-10.832,4.377-10.832s-8.568,3-10.83,4.378c-3.397,2.069-10.44,8.927-10.44,8.927L12.442,19.522z"
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "13.59,20.67  22.94,9.023 11.294,18.374  "
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M7.248,24.718l2.732,2.731l3.17-3.171 c0,0,1.078,1.628,1.659,1.625c0.71-0.004,2.007-2.007,2.007-2.007l-4.374-4.374l-4.374-4.375c0,0-2.004,1.298-2.008,2.008 c-0.003,0.581,1.626,1.659,1.626,1.659l-3.17,3.171L7.248,24.718L7.248,24.718z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M9.98,27.45c0,0-1.455,2.16-2.245,2.244 c-1.921,0.204-5.465-3.534-5.464-5.466c0-0.793,2.244-2.242,2.244-2.242L9.98,27.45z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "MDMG_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M12.442,19.522l3.985,3.984 c0,0,6.856-7.042,8.925-10.441c1.379-2.262,4.377-10.832,4.377-10.832s-8.568,3-10.83,4.378c-3.397,2.069-10.44,8.927-10.44,8.927 L12.442,19.522z"
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "13.59,20.67  22.94,9.023 11.294,18.374  "
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M7.248,24.718l2.732,2.731l3.17-3.171 c0,0,1.078,1.628,1.659,1.625c0.71-0.004,2.007-2.007,2.007-2.007l-4.374-4.374l-4.374-4.375c0,0-2.004,1.298-2.008,2.008 c-0.003,0.581,1.626,1.659,1.626,1.659l-3.17,3.171L7.248,24.718L7.248,24.718z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2C5583",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M9.98,27.45c0,0-1.451,2.244-2.245,2.244 c-1.932,0-5.465-3.534-5.464-5.466c0-0.793,2.244-2.242,2.244-2.242L9.98,27.45z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "AWA",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M29.884,18.253c0,0-13.853,20.668-27.767,0 H2.083c13.914-20.668,27.767,0,27.767,0H29.884z"
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    cx: 15.971,
    cy: 18.252,
    r: 6.104
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#808080",
    strokeMiterlimit: 10,
    cx: 15.967,
    cy: 18.252,
    r: 2.271
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M2.117,12.418c0,0,0.271-0.442,0.77-1.193c0.239-0.382,0.575-0.815,0.971-1.32 c0.2-0.249,0.399-0.532,0.638-0.8c0.242-0.265,0.557-0.477,0.842-0.747C5.623,8.09,5.953,7.848,6.293,7.594 c0.342-0.251,0.678-0.534,1.07-0.762c0.753-0.5,1.591-0.963,2.497-1.366c0.913-0.384,1.886-0.732,2.915-0.921 c1.021-0.234,2.09-0.28,3.149-0.275c1.059,0.057,2.116,0.187,3.122,0.453c1.006,0.261,1.976,0.594,2.868,1.008 c1.804,0.799,3.33,1.831,4.57,2.78c0.296,0.255,0.625,0.446,0.865,0.714c0.244,0.263,0.476,0.511,0.682,0.753 c0.421,0.477,0.764,0.911,1.043,1.269c0.549,0.725,0.811,1.172,0.811,1.172s-0.384-0.349-1.078-0.912 c-0.35-0.28-0.774-0.617-1.28-0.974c-0.249-0.183-0.523-0.366-0.811-0.558c-0.291-0.187-0.54-0.451-0.844-0.674 c-1.193-0.912-2.658-1.901-4.367-2.658c-0.848-0.394-1.761-0.706-2.703-0.951c-0.943-0.25-1.927-0.368-2.91-0.423 c-0.983-0.003-1.973,0.037-2.919,0.255c-0.954,0.175-1.859,0.5-2.712,0.858C9.413,6.76,8.624,7.194,7.912,7.668 c-0.37,0.214-0.69,0.485-1.016,0.723C6.573,8.632,6.258,8.862,5.985,9.121c-0.537,0.526-1.101,0.925-1.578,1.313 c-0.482,0.382-0.908,0.724-1.23,1.041C2.512,12.083,2.117,12.418,2.117,12.418z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "WGT"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M26.329,11.91l-0.856-0.975h-3.946c3.631,0,3.323-1.641,3.307-5.023 c-0.016-2.726-4.193-4.849-8.938-4.849c-4.743,0-8.921,2.123-8.936,4.849c-0.018,3.382-0.326,5.022,3.306,5.022H6.318L5.461,11.91 l-4.385,14.29l1.617,4.655h13.202h13.203l1.618-4.655L26.329,11.91z M15.895,8.42c-6.046,0.001-6.219,0.5-6.219-2.288 c0-1.471,3.982-2.664,6.219-2.664c2.238,0,6.221,1.193,6.221,2.665C22.116,8.921,21.942,8.421,15.895,8.42z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "REG",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#44B649",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "7.348,18.304 7.348,11.976  13.675,11.976 13.675,18.304 20.003,18.304 20.003,24.631 13.675,24.631 13.675,30.959 7.348,30.959 7.348,24.631 1.019,24.631  1.019,18.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#44B649",
    stroke: "#808080",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    points: "23.31,11.449  23.31,7.646 27.111,7.646 27.111,11.449 30.915,11.449 30.915,15.252 27.111,15.252 27.111,19.056 23.31,19.056 23.31,15.252  19.507,15.252 19.507,11.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#44B649",
    stroke: "#808080",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "15.989,3.571  15.989,1.063 18.497,1.063 18.497,3.571 21.007,3.571 21.007,6.08 18.497,6.08 18.497,8.589 15.989,8.589 15.989,6.08 13.481,6.08  13.481,3.571  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SUR",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.917,
    y: 25.982,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 22.069,
    height: 4.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.917,
    y: 21.031,
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    width: 22.069,
    height: 4.951
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    points: "15.951,1.563 1.996,13.083 4.917,13.083 4.917,21.031  26.986,21.031 26.986,13.083 29.904,13.083  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "WIL",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    stroke: "#808080",
    strokeMiterlimit: 10,
    d: "M5.708,20.667c0,0-0.903-1.152-1.24-2.104 c-0.439-1.243-0.382-4.012,0-5.274c0.427-1.412,2.077-4.049,3.274-4.911c0.985-0.709,3.47-1.259,4.683-1.273 c1.218-0.014,3.669,0.57,4.729,1.17c1.574,0.892,2.137,5.309,2.137,5.309l-0.813,1.708l0.905,1.542l1.292,1.567l-0.361,0.924 l-1.004,0.854l0.011,0.441l0.348,0.393l-0.331,0.415l0.067,0.533l-0.353,0.637l-0.352,0.467l0.283,1.238l-0.283,0.762l-1.274,0.409 l-2.456,0.637l-2.864-1.545c0,0-0.668,2.197-0.66,2.954c0.005,0.418,0.399,1.626,0.399,1.626s-0.811,1.24-1.24,1.449 c-0.763,0.369-2.599,0.441-3.388,0.13c-1.11-0.437-2.753-2.359-3.364-3.387C3.484,26.717,3.02,24.56,3.02,24.56l2.314-2.372 L5.708,20.667z"
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M17.856,5.092c0,0,0.189,0.011,0.509,0.05c0.158,0.021,0.356,0.094,0.591,0.181 c0.124,0.042,0.229,0.1,0.35,0.158c0.119,0.062,0.183,0.19,0.295,0.277c0.769,0.809,1.546,2.052,2.041,3.404 c0.506,1.347,0.748,2.797,0.667,3.914c-0.025,0.138,0.019,0.276-0.036,0.398c-0.049,0.122-0.117,0.236-0.169,0.34 c-0.109,0.209-0.202,0.384-0.315,0.516c-0.209,0.266-0.332,0.396-0.332,0.396s-0.011-0.183-0.03-0.503 c0.003-0.149-0.044-0.34-0.071-0.542c-0.034-0.204-0.096-0.426-0.044-0.661c0.073-0.952-0.142-2.272-0.606-3.507 c-0.452-1.24-1.17-2.373-1.826-3.062c-0.076-0.091-0.191-0.133-0.244-0.234c-0.052-0.102-0.101-0.208-0.152-0.282 c-0.108-0.155-0.189-0.325-0.296-0.448C17.972,5.243,17.856,5.092,17.856,5.092z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M20.253,3.015c0,0,0.222,0.028,0.6,0.098c0.187,0.037,0.414,0.136,0.686,0.249 c0.144,0.055,0.265,0.13,0.404,0.206c0.137,0.079,0.221,0.226,0.353,0.332c0.447,0.494,0.939,1.095,1.35,1.803 c0.433,0.696,0.8,1.487,1.107,2.298c0.149,0.408,0.291,0.818,0.396,1.234c0.128,0.409,0.19,0.829,0.276,1.229 c0.122,0.811,0.185,1.582,0.134,2.25c-0.027,0.165,0.015,0.331-0.042,0.478c-0.05,0.147-0.125,0.285-0.181,0.412 c-0.118,0.254-0.216,0.468-0.342,0.629c-0.229,0.328-0.364,0.493-0.364,0.493s0.001-0.218,0.002-0.6 c0.016-0.18-0.026-0.41-0.045-0.657c-0.023-0.248-0.081-0.521-0.026-0.812c0.046-0.586-0.011-1.286-0.122-2.027 c-0.08-0.368-0.136-0.754-0.256-1.134c-0.096-0.385-0.228-0.767-0.366-1.146c-0.286-0.754-0.628-1.491-1.026-2.13 c-0.377-0.655-0.823-1.192-1.217-1.629c-0.096-0.11-0.231-0.171-0.302-0.289c-0.07-0.119-0.137-0.243-0.207-0.329 c-0.146-0.182-0.256-0.377-0.392-0.516C20.401,3.183,20.253,3.015,20.253,3.015z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M23.029,1.263c0,0,0.244,0.04,0.659,0.129c0.206,0.047,0.454,0.164,0.75,0.294 c0.156,0.063,0.288,0.15,0.44,0.237c0.148,0.091,0.245,0.25,0.391,0.369c0.241,0.279,0.519,0.573,0.767,0.912 c0.247,0.34,0.51,0.698,0.734,1.094c0.482,0.774,0.891,1.656,1.233,2.56c0.167,0.454,0.324,0.912,0.44,1.375 c0.142,0.456,0.212,0.923,0.308,1.368c0.137,0.902,0.205,1.76,0.149,2.503c-0.029,0.184,0.012,0.367-0.046,0.531 c-0.052,0.164-0.131,0.317-0.188,0.458c-0.124,0.283-0.225,0.524-0.359,0.706c-0.242,0.369-0.386,0.557-0.386,0.557 s0.009-0.242,0.023-0.665c0.023-0.2-0.015-0.457-0.027-0.733c-0.017-0.277-0.072-0.584-0.016-0.912 c0.052-0.66-0.012-1.446-0.137-2.28c-0.09-0.413-0.152-0.847-0.287-1.273c-0.107-0.433-0.256-0.861-0.411-1.287 c-0.321-0.847-0.705-1.674-1.152-2.391c-0.209-0.37-0.45-0.696-0.676-1.008c-0.227-0.311-0.477-0.572-0.692-0.824 c-0.109-0.123-0.258-0.195-0.341-0.325c-0.082-0.131-0.159-0.267-0.243-0.361c-0.169-0.199-0.3-0.413-0.454-0.561 C23.199,1.443,23.029,1.263,23.029,1.263z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "WIL_copy",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#CCCCCC",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeDasharray: "3,2",
    d: "M8.486,17.961 c0,0-1.071-1.366-1.47-2.495c-0.521-1.474-0.453-4.756,0-6.252c0.507-1.674,2.462-4.8,3.881-5.821 c1.167-0.841,4.113-1.493,5.552-1.509c1.444-0.017,4.351,0.676,5.606,1.388c1.866,1.057,2.533,6.293,2.533,6.293l-0.964,2.025 l1.073,1.829l1.532,1.857l-0.429,1.095l-1.19,1.012l0.013,0.523l0.412,0.465l-0.392,0.494l0.079,0.631l-0.418,0.756l-0.416,0.553 l0.335,1.469l-0.335,0.902l-1.511,0.484l-2.911,0.754l-3.396-1.83c0,0-0.792,2.604-0.781,3.502 c0.006,0.496,0.474,1.926,0.474,1.926s-0.961,1.471-1.47,1.719c-0.905,0.438-3.081,0.523-4.017,0.154 c-1.316-0.518-3.264-2.797-3.988-4.014c-0.439-0.738-0.99-3.295-0.99-3.295l2.743-2.813L8.486,17.961z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgtAllow);
export default __webpack_public_path__ + "static/media/wgtAllow.2756ff254ed9c310e602430e0aea85da.svg";
export { ForwardRef as ReactComponent };